import React, { useEffect } from 'react'
import { callAgentMtdReportNorm } from '../../../services/reports/AgentMtdReportService'
import { extractTeamAgent, calcHierarchyEle, buildHierarchy, calcHierarchy, sumHierarchy } from '../../../services/reports/TeamTodayReportService'
import { resetWindow } from '../../../services/UtilService'
import TeamTodayReportComponent from '../TeamTodayReport/TeamTodayReportComponent'

const TeamMtdReport = (props) => {

    useEffect(() => {
        resetWindow()
    }, [])

    return <React.Fragment>
        <TeamTodayReportComponent
            buildHierarchy={buildHierarchy}
            sumHierarchy={sumHierarchy}
            calcHierarchy={calcHierarchy}
            extractTeam={extractTeamAgent}
            calcHierarchyEle={calcHierarchyEle}
            callTeamReport={callAgentMtdReportNorm}>
        </TeamTodayReportComponent>
    </React.Fragment>
}

export default TeamMtdReport